























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { setStorage } from "@common/utils";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import Dynamic from "@/zh-website/src/components/website/Dynamic.vue";
import Summary from "@/zh-website/src/components/website/Authent/Summary.vue";
import Category from "@/zh-website/src/components/website/Authent/Category.vue";
import Grade from "@/zh-website/src/components/website/Authent/Grade.vue";
@Component({
  components: {
    Banner,
    Dynamic,
    Summary,
    Category,
    Grade
  }
})
export default class Autnent extends Vue {
  offsetTop = 0;
  isFixed = false;
  dynamicList = {
    title: "捷报频传",
    list: []
  };
  bannerData = {
    font1: "华为认证",
    font2: "赢自认证 智驭未来",
    font6: "提升职业起点  拓展职业通道  预见职业未来",
    button: "",
    style: {
      "background-image":
        'url("' + require("../../assets/renz_banner.jpg") + '")',
      height: "495px"
    }
  };
  tabs = [
    {
      title: "概述"
    },
    {
      title: "认证类别"
    },
    {
      title: "认证等级"
    }
    // {
    //   title: '开班计划'
    // },
    // {
    //   title: '在线学习'
    // }
  ];
  // 选中的项
  activeIndex = 0;
  mounted() {
    this.getVictory();
    // handleScroll为页面滚动的监听回调
  }

  isIE() {
    //ie?
    if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
    else return false;
  }
  // 鼠标hover事件
  changeMask(e) {
    this.activeIndex = e;
    // 判断当前tab有没有吸顶
    if (this.isFixed) {
      if (this.isIE()) {
        document.documentElement.scrollTop = this.offsetTop;
      } else {
        this.$nextTick(() => {
          window.scrollTo({
            top: this.offsetTop,
            behavior: "smooth"
          });
        });
      }
    }
  }
  // 培训捷报
  async getVictory() {
    const res: any = [
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1:
          "北京12名学员参加HCIA-GaussDB(for MySQL)华为认证数据库工程师培训",
        dictCode: "059",
        id: "R88ojp91688455048363",
        field2: "2023-06-26",
        group: "059",
        createDate: 1688455048000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "北京5名学员参加HCIE-Datacom华为数通专家认证培训",
        dictCode: "059",
        id: "581520m1688455036373",
        field2: "2023-05-29",
        group: "059",
        createDate: 1688455036000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "系统部5名学员参加HCIE-Datacom华为数通专家认证培训",
        dictCode: "059",
        id: "d56516p1688455026132",
        field2: "2023-05-29",
        group: "059",
        createDate: 1688455026000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "广东5名学员参加HCIE-Datacom华为数通专家认证培训",
        dictCode: "059",
        id: "52e12H61688455015621",
        field2: "2023-05-29",
        group: "059",
        createDate: 1688455015000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "系统部4名学员参加HCIE-Transmission华为认证传送网专家培训",
        dictCode: "059",
        id: "32Xh6uz1688454980414",
        field2: "2023-05-29",
        group: "059",
        createDate: 1688454980000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "山东4名学员参加HCIE-Transmission华为认证传送网专家培训",
        dictCode: "059",
        id: "90825XC1688454966098",
        field2: "2023-05-29",
        group: "059",
        createDate: 1688454966000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "辽宁16名学员参加HCIA-AI 华为认证AI工程师培训",
        dictCode: "059",
        id: "57U0GOO1685948446054",
        field2: "2023-05-26",
        group: "059",
        createDate: 1685948446000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "系统部1名学员参加HCIA-Big Data华为认证大数据工程师培训",
        dictCode: "059",
        id: "g66744f1685948436458",
        field2: "2023-05-19",
        group: "059",
        createDate: 1685948436000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1:
          "系统部3名学员参加HCIP-Intelligent Vision华为认证机器视觉高级工程师培训",
        dictCode: "059",
        id: "y6AjwQR1685948427897",
        field2: "2023-05-23",
        group: "059",
        createDate: 1685948427000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1:
          "山西3名学员参加HCIP-Intelligent Vision华为认证机器视觉高级工程师培训",
        dictCode: "059",
        id: "1f3m5Qr1685948419614",
        field2: "2023-05-23",
        group: "059",
        createDate: 1685948419000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1:
          "辽宁16名学员参加HCIP-AI-Ascend Developer华为认证昇腾开发高级工程师培训",
        dictCode: "059",
        id: "X2b4LaU1685948411660",
        field2: "2023-05-19",
        group: "059",
        createDate: 1685948411000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "广东3名学员参加HCIE-Storage华为认证存储专家培训",
        dictCode: "059",
        id: "hX2y0041685948401389",
        field2: "2023-05-26",
        group: "059",
        createDate: 1685948401000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1:
          "系统部1名学员参加HCIP-Cloud Computing华为认证云计算高级工程师培训",
        dictCode: "059",
        id: "37WR5QF1685948392027",
        field2: "2023-05-18",
        group: "059",
        createDate: 1685948392000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "湖南3名学员参加HCIP-Transmission华为认证传送网高级工程师培训",
        dictCode: "059",
        id: "42GTd961685948383526",
        field2: "2023-05-19",
        group: "059",
        createDate: 1685948383000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "四川4名学员参加HCIP-Transmission 华为认证传送网高级工程师培训",
        dictCode: "059",
        id: "363264Y1685948374860",
        field2: "2023-05-26",
        group: "059",
        createDate: 1685948374000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1:
          "四川4名学员参加HCIA-Data Center Facility 华为认证网络能源工程师培训",
        dictCode: "059",
        id: "Hi3gSfU1685948363214",
        field2: "2023-04-27",
        group: "059",
        createDate: 1685948363000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1:
          "广东3名学员参加HCIA-Intelligent Computing 华为认证智能计算工程师培训",
        dictCode: "059",
        id: "yhI09GN1685948352916",
        field2: "2023-04-14",
        group: "059",
        createDate: 1685948352000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "浙江3名学员参加HCIA-Transmission华为认证传送网工程师培训",
        dictCode: "059",
        id: "2llu01k1685948340560",
        field2: "2023-04-21",
        group: "059",
        createDate: 1685948340000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "新疆5名学员参加HCIA-Datacom华为认证数通工程师培训",
        dictCode: "059",
        id: "2Jznc2Z1685948322537",
        field2: "2023-04-28",
        group: "059",
        createDate: 1685948322000
      },
      {
        tag1: 0,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "甘肃5名学员参加HCIA-Datacom华为认证数通工程师培训",
        dictCode: "059",
        id: "06J92YW1685948311307",
        field2: "2023-04-28",
        group: "059",
        createDate: 1685948311000
      }
    ];
    const arr: any = [];
    for (let x = 0; x < res.length; x++) {
      arr.push(res[x].field2 + "，" + res[x].field1);
    }
    this.dynamicList.list = arr;
  }
  //
  clickMask(e) {
    // if (e == this.tabs.length - 1) {
    //   window.location.href =
    //     'https://www.ictxuetang.com/cict/pc/course/list?property_id=19041809-3281-8174-84cd-a0c098681904'
    // }
  }
}
